import React from 'react';
import { Vehicle } from '@spike/vehicle-model';
import VehicleRow from './VehicleRow';
import Spinner from 'components/UI/Spinner';
import { Table } from 'components/UI/V3/Table/Table';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import DefaultTableEmptyState from 'components/UI/V3/Table/EmptyState/DefaultTableEmptyState';
import { useMediaQuery } from 'react-responsive';

interface VehiclesTableProps {
    vehicles: Vehicle[];
    isLoading: boolean;
    onEdit: (vehicle: Vehicle) => void;
    onActivate: (vehicle: Vehicle) => void;
    onDeactivate: (vehicle: Vehicle) => void;
}

const VehiclesTable: React.FC<VehiclesTableProps> = ({ vehicles, isLoading, onEdit, onActivate, onDeactivate }) => {
    const isMobile = useMediaQuery({ query: '(max-width:768px)' });

    // Loading state
    if (isLoading) {
        return (
            <Table fullHeight>
                <TableBody>
                    <tr>
                        <td
                            colSpan={3}
                            style={{ textAlign: 'center', padding: '40px' }}
                        >
                            <Spinner />
                        </td>
                    </tr>
                </TableBody>
            </Table>
        );
    }

    // Empty state
    if (vehicles.length === 0) {
        return (
            <Table fullHeight>
                <TableBody>
                    <DefaultTableEmptyState />
                </TableBody>
            </Table>
        );
    }

    // Table with data
    return (
        <Table fullHeight>
            {!isMobile && (
                <TableHeader>
                    <TableHeaderCell style={{ width: '40%', maxWidth: '350px' }}>Vehicle</TableHeaderCell>
                    <TableHeaderCell>Max # of Pets</TableHeaderCell>
                    <TableHeaderCell></TableHeaderCell>
                </TableHeader>
            )}
            <TableBody>
                {vehicles.map((vehicle, index) => (
                    <VehicleRow
                        key={vehicle.id || vehicle.uuid}
                        vehicle={vehicle}
                        isLast={vehicles.length === index + 1}
                        isMobile={isMobile}
                        onEdit={onEdit}
                        onActivate={onActivate}
                        onDeactivate={onDeactivate}
                    />
                ))}
            </TableBody>
        </Table>
    );
};

export default VehiclesTable;
